var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.item,
    _vm.classDevice(_vm.$style),
    ( _obj = {}, _obj[_vm.$style.large] = _vm.large, _obj[_vm.$style.small] = !_vm.large, _obj ) ]},[_c('component-image',{class:[
      _vm.$style.image,
      _vm.classDevice(_vm.$style),
      ( _obj$1 = {}, _obj$1[_vm.$style.large] = _vm.large, _obj$1[_vm.$style.small] = !_vm.large, _obj$1 ) ],attrs:{"image":_vm.image,"title":_vm.title,"alt":_vm.title}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }